import { TypesOverride, useTenantSetting } from "@nestoca/multi-tenant";
import { KeepI18ExprHappy } from "@shared/utils";
import { useTranslation } from "react-i18next";

type Option = { value: string; label: string };

export const useTypesOverrideOptions = ({
  settingKey,
  labelMap,
  defaultValue = [],
  translate = true,
}: {
  settingKey: keyof TypesOverride;
  labelMap: Record<string, string | undefined>;
  defaultValue?: Option[];
  translate?: boolean;
}): Option[] => {
  const { settings } = useTenantSetting("typesOverride");
  const { t } = useTranslation();

  const values = settings?.[settingKey] as string[] | undefined;

  const options: Option[] = values
    ? values
        .filter((v) => !!labelMap[v])
        .map((v) => ({ value: v, label: labelMap[v] as string }))
    : defaultValue;

  if (!translate) return options;

  return options.map(({ value, label }) => ({
    value,
    label: t(label as KeepI18ExprHappy) as string,
  }));
};
